/**
 * Converts a kebab-case string to Title Case.
 * @function convertToTitleCase
 * @param {string} str - The kebab-case string to convert.
 * @returns {string} The converted Title Case string.
 */
export const convertToTitleCase = (str: string) => {
  const words = str.split('-');
  const capitalizedWords = words.map((word) => {
    const firstLetter = word.charAt(0).toUpperCase();
    const restOfWord = word.slice(1);
    return firstLetter + restOfWord;
  });

  return capitalizedWords.join(' ');
};
